<script lang="ts" setup>
import type { UIProp } from '~/types/elementsUi'
import type { TailwindColor } from '#shared/types/elementsUi'

interface QuoteSectionProps {
  type: 'quote' | 'tip'
  title?: string
  person?: string
  occupation?: string
  baseKey?: string
  dividerLabel?: string
  backgroundColor?: TailwindColor
  noBottomDivider?: boolean
  ui?: UIProp<'section' | 'title' | 'description'>
}

const props = withDefaults(defineProps<QuoteSectionProps>(), {
  title: undefined,
  person: undefined,
  dividerLabel: undefined,
  backgroundColor: undefined
})

const { t, te } = useI18n(props.baseKey)

const computedUi = computed(() =>
  nuxtUiMerge(props.ui, {
    section: props.backgroundColor && `bg-${props.backgroundColor}`
  })
)
</script>

<template>
  <VSection class="text-center" :ui="computedUi">
    <template #content>
      <VDivider class="mb-10" :label="dividerLabel" />
      <q
        v-if="type === 'quote'"
        class="max-w-150 text-h4 font-semibold lg:text-h3 lg:font-bold xl:max-w-section"
      >
        <slot name="quote">{{ title && te(title) ? t(title) : title }}</slot>
      </q>
      <h3
        v-else
        class="inline-block max-w-150 text-h4 font-semibold text-pink-800 lg:text-h3 lg:font-bold dark:text-pink-300"
      >
        <slot name="tip">{{ title && te(title) ? t(title) : title }}</slot>
      </h3>
      <p
        v-if="person"
        class="mt-4 font-semibold text-pink-800 lg:font-bold dark:text-pink-300"
        :class="occupation && 'text-h4'"
      >
        {{ person && te(person) ? t(person) : person }}
      </p>
      <p
        v-if="occupation"
        class="font-semibold text-pink-800 lg:font-bold dark:text-pink-300"
      >
        {{ occupation && te(occupation) ? t(occupation) : occupation }}
      </p>
      <VDivider v-if="!noBottomDivider" class="mt-10" />
    </template>
  </VSection>
</template>

<style scoped></style>
